<div class="wre-placement-excellence-container wre-main-container" id="placement-excellence-home-container" style="">
    <div class="row justify-content-center">
        <ng-container *ngFor="let item of itemCollection">
            <app-placement-excellence-card class="placement-excellence-card col-12 col-md-6 col-lg-3 mb-3" title="{{item.title}}" description="{{item.description}}" cardImage="{{item.cardImage}}" route="{{item.route}}">
            </app-placement-excellence-card>
        </ng-container>
    </div>
</div>